export interface IArea {
  name: String
  primaryNode: Object
  description: String
}
const initValue = {
  name: '',
  primaryNode: {},
  description: ''
}
export default {
  initValue
}
